import * as React from "react";
import { SVGProps } from "react";

const Ignis = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 635" {...props}>
    <path
      fill="#f9c011"
      d="M280.054 87.9 149.254 0l-100.1 263 64 121.3 166.9-296.4z"
    />
    <path
      fill="#db712a"
      d="m360.019 230.108-74.2-133-285.8 520.9h143.3l216.7-387.9z"
    />
    <path
      fill="#b7230f"
      d="m278.878 424.213-118.2 210.8 191.2-115.4-73-95.4z"
    />
  </svg>
);

export default Ignis;
